import type {GradientPalette} from '../types';
import {PALETTE_ID} from '../types';

export default {
    id: PALETTE_ID.NEUTRAL_20,
    scheme: [
        '#EAEAEA',
        '#E3E3E3',
        '#DBDBDB',
        '#D3D3D3',
        '#CCCCCC',
        '#C4C4C4',
        '#BCBCBC',
        '#B5B5B5',
        '#ADADAD',
        '#A6A6A6',
        '#9E9E9E',
        '#969696',
        '#8F8F8F',
        '#878787',
        '#7F7F7F',
        '#787878',
        '#707070',
        '#686868',
        '#616161',
        '#595959',
    ],
    gradient: true,
} as GradientPalette;
